// extracted by mini-css-extract-plugin
export var header = "_to-1";
export var maskBottom = "_to-6";
export var maskMiddle = "_to-7";
export var maskTop = "_to-5";
export var root = "_to-0";
export var scrollDownButton = "_to-3";
export var scrollDownButtonHidden = "_to-4";
export var viewport = "_to-2";